import * as Sentry from '@sentry/react';

import { appEnv } from '@/app/config/env';
import { APP_VERSION } from '@/app/config/version';

const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;

Sentry.init({
  dsn: appEnv.sentryDSN,
  environment: import.meta.env.MODE,
  enabled: !!appEnv.sentryDSN && isProduction,
  release: import.meta.env.VITE_APP_VERSION || 'unknown',

  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: true,
      networkDetailAllowUrls: [],
      networkCaptureBodies: false,
      networkRequestHeaders: [],
      networkResponseHeaders: [],
      beforeErrorSampling: (event) => {
        if (event.exception) {
          const error = event.exception.values?.[0];
          if (error?.value?.includes('ResizeObserver loop limit exceeded')) {
            return false;
          }
        }
        return true;
      },
    }),

    Sentry.httpContextIntegration(),

    Sentry.breadcrumbsIntegration({
      console: true,
      dom: true,
      fetch: false,
      history: true,
      sentry: true,
      xhr: false,
    }),
  ],

  tracesSampleRate: isProduction ? 0.1 : 0,
  profilesSampleRate: isProduction ? 0.1 : 0,
  replaysSessionSampleRate: isProduction ? 0.1 : 0,
  replaysOnErrorSampleRate: isProduction ? 1.0 : 0,

  tracePropagationTargets: ['localhost', /^https:\/\/.*\.globo\.com/],

  beforeSend(event) {
    if (event.exception) {
      const error = event.exception.values?.[0];

      if (error?.value?.includes('Non-Error promise rejection captured')) {
        return null;
      }

      if (error?.value?.includes('NetworkError') && !isProduction) {
        return null;
      }
    }

    return event;
  },

  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category === 'console' && breadcrumb.message?.includes('password')) {
      breadcrumb.message = '[MASKED]';
    }

    return breadcrumb;
  },

  initialScope: {
    tags: {
      version: APP_VERSION,
      component: 'podcast-ai-frontend',
    },
  },

  transport: isDevelopment
    ? undefined
    : Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),

  debug: isDevelopment,
});
